import React from "react";
import Hero from "../Hero";
import CoinsTable from "../CoinsTable";
export default function Coins() {
  return (
    <div className="coinpage">
      <Hero></Hero>
      <CoinsTable></CoinsTable>
    </div>
  );
}
